
import { defineComponent } from "vue";
import { CommonDialog } from "@/components/Common";
import { useDialogCommon } from "@/hooks";
import { expressServiceDetail } from "@/config/service-detail";

export default defineComponent({
  props: {
    visible: { type: Boolean, default: false },
    formData: {
      type: Object,
      default: () => ({}),
    },
  },

  components: {
    CommonDialog,
  },

  emits: ["update:visible"],

  setup(props, context) {
    const { visibleRef } = useDialogCommon(props, context);


    return {
      visibleRef,
      expressServiceDetail
    };
  },
});
